import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconFadeOut12 from './IconFadeOut12';
import IconFadeOut16 from './IconFadeOut16';
import IconFadeOut20 from './IconFadeOut20';
import IconFadeOut24 from './IconFadeOut24';
import IconFadeOut32 from './IconFadeOut32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconFadeOut = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconFadeOut12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconFadeOut16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconFadeOut20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconFadeOut24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconFadeOut32 {...props} />}
        </span>
    );
};
IconFadeOut.displayName = 'FondueIconFadeOut';

export default memo(IconFadeOut);
